<div *ngIf="visible" class="modal-backdrop" (click)="backdropClick($event)">
    <div class="modal">
        <ng-content></ng-content>
    </div>
</div>
